<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">CNA Box</a></li>
                            <li>Extrato de Uso das Escolas</li>
                        </ul>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Extrato de Uso das Escolas</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">

                                <div class="form-group col-md-6">
                                    <label for="escolaBoxId">Escola</label>
                                    <select v-select="{ dataitem: 'Escola', default: 'Selecione' }" v-model="filter.escolaBoxId" class="form-control" name="escolaBoxId"></select>
                                </div>
                                
                                <div class="form-group col-md-6">
                                    <label for="dataVencimento">Data de Vencimento</label>
                                    <input type="text" v-datepicker class="form-control" autocomplete="off" name="dataVencimento" v-model="filter.dataVencimento" required />
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Escola<i @click="executeOrderBy('DataGeracao')" class="fa fa-sort"></i></th>
                                    <th>Data Referência Inicio<i @click="executeOrderBy('DataReferenciaInicio')" class="fa fa-sort"></i></th>
                                    <th>Data Referência Fim<i @click="executeOrderBy('DataReferenciaFim')" class="fa fa-sort"></i></th>
                                    <th>Data de Vencimento<i @click="executeOrderBy('DataVencimento')" class="fa fa-sort"></i></th>
                                    <th>Valor Total SMS Excedido<i @click="executeOrderBy('ValorExcedidosEnvioSMS')" class="fa fa-sort"></i></th>
                                    <th>Valor Excedido Meu CNA<i @click="executeOrderBy('ValorExcedidosContratoTalk')" class="fa fa-sort"></i></th>
                                    <th>Valor Licença de Uso Box<i @click="executeOrderBy('ValorLicencaUsoBox')" class="fa fa-sort"></i></th>
                                    <th>% Desconto SMS Enviado<i @click="executeOrderBy('PercentualDescontoTotalEnvioSMS')" class="fa fa-sort"></i></th>
                                    <th>% Desconto Meu CNA<i @click="executeOrderBy('PercentualDescontoTotalContratoTalk')" class="fa fa-sort"></i></th>
                                    <th>% Desconto Licença de Uso Box<i @click="executeOrderBy('PercentualDescontoLicencaUsoBox')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.escolaBox.escola.nomeEscola }}</td>
                                    <td>{{ item.dataReferenciaInicio }}</td>
                                    <td>{{ item.dataReferenciaFim }}</td>
                                    <td>{{ item.dataVencimento }}</td>
                                    <td>{{ item.valorExcedidosEnvioSMS }}</td>
                                    <td>{{ item.valorExcedidosContratoTalk }}</td>
                                    <td>{{ item.valorLicencaUsoBox }}</td>
                                    <td>{{ item.percentualDescontoTotalEnvioSMS }}</td>
                                    <td>{{ item.percentualDescontoTotalContratoTalk }}</td>
                                    <td>{{ item.percentualDescontoLicencaUsoBox }}</td>
                                    <td class="text-center">
                                        <button type="button" v-b-tooltip title="Editar" class="btn btn-sm btn-primary" @click="openEdit({ extratoEscolaBoxId: item.extratoEscolaBoxId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="extratoEscolaBoxId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'extratoescolabox',
        mixins: [base],
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'extratoescolabox',
                    remove: 'extratoescolabox'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    escolaBoxId: ""
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.extratoEscolaBoxId = model.extratoEscolaBoxId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>